import React, { useState, memo, useEffect, useMemo, useContext } from "react";
import { Link  } from "react-router-dom";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import PaginationComponent from "../../components/common/Pagination";
// Pages
import Breadcrumbs from "../../components/common/Breadcrumb";
import {
    handleAddEditDistributorApi,
    getAllDistributorDetailsApi,
    handleChangeDistributorStatusApi,
    fetchSingleDistributorDetailsApi
} from "../../api/distributorApi";
import {
roles
} from "../../utils/constants"
import { AuthContext } from "../../contexts/AuthContext";
import { useAppSettings } from '../../contexts/AppSettingsContext';

function Distributors() {
  const { appSettings } = useAppSettings();
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  

  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const [distributorModal, setDistributorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [distributors, setDistributors] = useState([]);
  const [popUpMode, setPopUpMode] = useState("");
  const [singleDistributorDetails, setSingleDistributorDetails] = useState({});
  const { authToken } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);
  

  // Set token
  useEffect(() => {
    if (authToken) {
      fetchAllDistributors();
    }
  }, [authToken, currentPage]);

  // Function handle open & close modal
  const toggle = () => {
    setDistributorModal(!distributorModal);
    if (!distributorModal) {
      // # Reset form to initial values when modal is closed
      distributorForm.resetForm();
      setErrorMessage("");
      setSuccessMessage("");
      setSingleDistributorDetails({});
      setPopUpMode("");
    }
  };

  // #Handle Distributor form
  const distributorForm = useFormik({
    enableReinitialize : true,
    initialValues: {
      name: singleDistributorDetails?.name || "",
      email: singleDistributorDetails?.email ||  "",
      contact_person: singleDistributorDetails?.contact_person ||  "",
      contact_no: singleDistributorDetails?.contact_no || "",
      emergency_contact_no: singleDistributorDetails?.emergency_contact_no ||  "",
      website_url:  singleDistributorDetails?.website_url ||  "",
      portal_url : singleDistributorDetails?.portal ||  "",
      description : singleDistributorDetails?.description || "", // (if any additional notes )
      address:singleDistributorDetails?.address ||  ""
    },
    validationSchema: Yup.object({
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
      emergency_contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {

      // Trim all string values
      const trimmedValues =  Object.keys(values).reduce((acc, key)=>{
          acc[key]  = typeof values[key] == 'string' ? values[key].trim() : values[key]  
          return acc
      },{})
      trimmedValues.isEdit  =  false

      if(popUpMode == 'EDIT'){
          const distributorId = singleDistributorDetails?.id
          trimmedValues.isEdit  = true
          trimmedValues.id   = distributorId
      }
      console.log("submitted values ->", trimmedValues);
      handleAddEditDistributor(trimmedValues);
      setSuccessMessage("");
    },
  });

  // Function handle Distributor  add edit functionality
  async function handleAddEditDistributor(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditDistributorApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllDistributors(authToken);
            setDistributorModal(false);
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Function for fetch all distributors
  async function fetchAllDistributors() {
    try {
      let response = await getAllDistributorDetailsApi(authToken, currentPage, itemsPerPage);
      const responseData  =  response?.data
      if (response?.code == 200) {
            setDistributors(responseData?.distributors || []);
            setTotalPages(Math.ceil((responseData.totalCount  || 1) / itemsPerPage));
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

    // Function for change products status 
    const handleChangeDistributerStatus = async(distId) =>{
      try{
  
        let response = await handleChangeDistributorStatusApi(distId, authToken);
        if (response?.code == 200) {

            const updatedDistributors = distributors?.map((item)=>
            distId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
            setDistributors(updatedDistributors);
        } 
      }catch(error){
          console.log("error",error);
      }
    }

  // Function for fetch single  distributor details based on the distributor id 
  const fetchSingleDistributorDetails= async(distributorId) =>{
    try{
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchSingleDistributorDetailsApi(authToken, distributorId);
      if (response?.code == 200) {
        toggle();
        setSingleDistributorDetails(response?.data || []);
      }
      setPopUpMode("EDIT");
    
    }catch(err){
      console.log("err",err.message);
    }
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={appName} breadcrumbItem="Distributors" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1 ">
                <Button color="success" onClick={toggle}>
                  Add Distributor
                </Button>
              </CardHeader>
              <OpenPopUp
                distributorModal={distributorModal}
                toggle={toggle}
                distributorForm={distributorForm}
                errorMessage={errorMessage}
                successMessage={successMessage}
                popUpMode={popUpMode}
              />
              <CardBody>
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Code</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Contact Person</th>
                      <th>Contact Number</th>
                      {/* <th>Website URL</th> */}
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {distributors?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{  color: 'rgb(47 123 191)', fontWeight: 'bold', backgroundColor: '#f0f8ff', padding: '10px'}} >{item.distributor_code}</td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.contact_person}</td>
                        <td>{item.contact_no}</td>
                        {/* <td className="text-primary">
                            <a href={item.portfolio} target="_blank" rel="website_url" className="text-primary">
                              {item.website_url}
                            </a>
                        </td> */}
                        <td>
                          <Button color={`${item.status == 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={()=>{handleChangeDistributerStatus(item.id)}}>
                            {item.status}
                          </Button>
                        </td>
                        <td>
                        <Button  color={`success`} type="button" onClick={()=>{fetchSingleDistributorDetails(item.id)}}>
                            Edit
                          </Button>
                        </td>
                       </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
              <div  className=" d-flex justify-content-end">
                <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Distributors;

const OpenPopUp = ({
  distributorModal,
  toggle,
  distributorForm,
  errorMessage,
  successMessage,
  popUpMode
}) => {
  return (
    <div>
      <Modal size="xl" isOpen={distributorModal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{ popUpMode !== 'EDIT' ? 'Add Distributor' : 'Edit Distributor'}</ModalHeader>
        <Form onSubmit={distributorForm.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="distributer_name">Name:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.name}
                    required
                    onChange={distributorForm.handleChange}
                    id="distributer_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="distributer_email">Email:</Label>
                  <Input
                    type="email"
                    id="distributer_email"
                    value={distributorForm.values.email}
                    required
                    onChange={distributorForm.handleChange}
                    name="email"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="dist_contact_person">Contact Person:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.contact_person}
                    required
                    onChange={distributorForm.handleChange}
                    id="dist_contact_person"
                    name="contact_person"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
              <FormGroup>
                  <Label htmlFor="dist_contact_number">Contact Number:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.contact_no}
                    required
                    onChange={distributorForm.handleChange}
                    id="dist_contact_number"
                    name="contact_no"
                  />
                </FormGroup>
                {distributorForm.errors.contact_no &&
                  distributorForm.errors.contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {distributorForm.errors.contact_no}
                    </div>
                  ) : null}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="dist_emergency_contact_no">
                    Emergency Contact Number:
                  </Label>
                  <Input
                    type="text"
                    id="dist_emergency_contact_no"
                    value={distributorForm.values.emergency_contact_no}
                    onChange={distributorForm.handleChange}
                    name="emergency_contact_no"
                  />
                </FormGroup>
                {distributorForm.errors.emergency_contact_no &&
                  distributorForm.errors.emergency_contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {distributorForm.errors.emergency_contact_no}
                    </div>
                  ) : null}
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="dist_portal_url ">Portal URL:</Label>
                  <Input
                    type="text"
                    id="dist_portal_url"
                    value={distributorForm.values.portal_url}
                    onChange={distributorForm.handleChange}
                    name="portal_url"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label htmlFor="dist_website_url ">Website URL:</Label>
                  <Input
                    type="text"
                    id="dist_website_url"
                    value={distributorForm.values.website_url}
                    onChange={distributorForm.handleChange}
                    name="website_url"
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="dist_description">Notes</Label>
                  <textarea
                    className="selectInput"
                    id="dist_description"
                    name="description"
                    value={distributorForm.values.description}
                    onChange={distributorForm.handleChange}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="dist_contact_address">Contact Address</Label>
                  <textarea
                    className="selectInput"
                    id="dist_contact_address"
                    name="address"
                    value={distributorForm.values.address}
                    onChange={distributorForm.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

